import { createAsyncThunk } from '@reduxjs/toolkit';
import { IState } from '../..';
import { httpService } from '../../..';
import { AppDispatch } from '../../../components/hooks/useAppDispatch';
import { IEntityWithMessages } from '../../../services/HttpService';
import { executeApiRequest } from '../../asyncUtils';
import { processMessagesThunk, showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { ILoadApiResponse } from '../logisticsInterfaces';

export const closeLoad = createAsyncThunk<void, string, { dispatch: AppDispatch; state: IState }>(
  'logistics/closeLoad',
  async (loadNumber, { dispatch, getState }) => {
    dispatch(uiActionCreators.showSpinnerDialog());
    const response = await executeApiRequest<IEntityWithMessages<ILoadApiResponse>>(() =>
      httpService.post(`/Logistics/Loads/${loadNumber}/Close`)
    );

    if (response.requestFailed) {
      showFailedRequestDialogThunk(response, getState(), dispatch);
    } else if (response.value) {
      processMessagesThunk({ response: response.value, dispatch });

      if (response.value.value) {
        dispatch(logisticsActionCreators.setLoad(response.value.value));
      }
    }

    dispatch(uiActionCreators.hideSpinnerDialog());
  }
);
